import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ImageModalActionsDrawIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon image-modal-actions-draw"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinejoin="round"
            strokeWidth={1.67}
            d="m15.69 7.899 2.25-2.66a1.666 1.666 0 0 0-.094-2.255l-.778-.777a1.667 1.667 0 0 0-2.255-.094l-2.66 2.25m-7.997 8.252-.913 2.13a.83.83 0 0 0 .176.918l.97.97a.835.835 0 0 0 .918.177l2.13-.913a8.3 8.3 0 0 0 2.61-1.767l5.348-5.347c.65-.651.65-1.707 0-2.357l-1.768-1.768a1.667 1.667 0 0 0-2.357 0l-5.347 5.347a8.3 8.3 0 0 0-1.767 2.61Zm-2.02 5.301 1.179-2.946 1.768 1.767z"
        />
    </svg>
);
const Memo = memo(ImageModalActionsDrawIcon);
export default Memo;
